<script lang="ts">
import SectionCheckPayedList from '@/generated/sections/SectionCheckPayedList.vue';
import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
import Transaction from '@/extend/classes/Transaction';
import { TransactionTypes, TransactionStatuts } from '@/generated/classes/Transaction';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: SectionCheckPayedList,
    computed: {
        headers() {
            return [
                { text: "Date d'encaissement", value: 'datePayed', cellClass: '', sortable: true },
                { text: "Destinataire", value: 'ownerLabel', cellClass: '', sortable: true },
                { text: "Numéro", value: 'reference', cellClass: '', sortable: true },
                { text: "Montant", value: 'amount', cellClass: '', sortable: true },
                { text: 'Action(s)', width: '20%', value: 'action', cellClass: 'iterate-cell-class iterate-cell-action', sortable: false },
            ];
        },
        canAdd(): boolean {
            return false;
        }
    },
    methods: {
        canUpdate(transaction: Transaction): boolean {
            return true;
        },
        defaultFilter(): void {
            {
                const columnFilter = new ColumnFilter();
                columnFilter.name = "type";
                columnFilter.staticFilter = true;
                const choix = new ListChoix();
                choix.value = TransactionTypes.CHEQUE_EMIS;
                columnFilter.filters.push(choix);
                this.activeFilters.push(columnFilter);
            }
            {
                const columnFilter = new ColumnFilter();
                columnFilter.name = "statut";
                columnFilter.staticFilter = true;
                const choix = new ListChoix();
                choix.value = TransactionStatuts.PAYED;
                columnFilter.filters.push(choix);
                this.activeFilters.push(columnFilter);
            }
        }
    }
})

</script>
